export const UNREACHABLE_MESSAGE = `This message will not be sent to contacts if they have not sent you a message
 within the last 24 hours`;
